import api from '@pray/shared/utils/api';

type GenerateImageRequest = {
  prompt: string;
  aspectRatio: string;
  referenceImageUrls?: string[];
};

type GenerateImageResponse = {
  url: string;
  revisedPrompt: string;
};

type GenerateImageProps = {
  artistId: string;
  prompt: string;
  aspectRatio: string;
  referenceImageUrls?: string[];
};

export const generateImage = async ({ artistId, prompt, aspectRatio, referenceImageUrls }: GenerateImageProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!prompt) throw Error('Prompt is required');

  const url = `/web/studio/artists/${artistId}/images/generate`;
  const body: GenerateImageRequest = { prompt, aspectRatio };
  if (referenceImageUrls?.length) {
    body.referenceImageUrls = referenceImageUrls;
  }

  const response = await api.executePostRequest<{ data: GenerateImageResponse }>(url, body);
  return response?.data?.data;
};
